import styled from 'styled-components';
// *** Components ***
const XingLogo = styled.div ``;
export const Styled = {
    XingLogo,
};
//# sourceMappingURL=xing-logo.styles.js.map